import PropTypes from 'prop-types';

const AddressPropType = {
  city: PropTypes.string,
  country: PropTypes.string,
  line1: PropTypes.string,
  postalCode: PropTypes.string,
  state: PropTypes.string,
  unit: PropTypes.string,
};

export default AddressPropType;
